import { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

const SelectYear = ({ control,defaultValue }) => {

    const titleOptions = useMemo(() => {
        const yearNow = new Date().getFullYear()
        const startYear = 2021
        const years = []
        for (let i = startYear; i <= yearNow; i++) {
            years.push({ value: i, label: i + 543 })
        }
        return years
    }, [])

    return (
        <Controller
            name="year"
            defaultValue={defaultValue && titleOptions.find(v=>v.value===defaultValue)}
            control={control}
            render={({ field }) => <Select options={titleOptions} placeholder="เลือก" {...field} isClearable />}
        />
    )
}

export default SelectYear
